import { Plus, Type, Image as ImageIcon, Megaphone, LayoutTemplate } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { BLOCK_SCHEMAS } from "@/components/home/pageBlocks";

const CUSTOM = [
  ["text", Type, "Überschrift und Text"],
  ["image_text", ImageIcon, "Bild neben Text, optional mit Knopf"],
  ["banner", Megaphone, "Schmale Leiste mit Hinweis und Knopf"],
];

export const AddBlockMenu = ({ blocks, onAdd }) => {
  const missing = Object.entries(BLOCK_SCHEMAS).filter(([t, s]) => s.builtin && !blocks.some((b) => b.type === t));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-black font-bold text-sm hover:bg-[#EFDF00] transition-colors duration-150"
          data-testid="editor-add-block-btn">
          <Plus className="w-4 h-4" /> Bereich hinzufügen
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-72" align="start">
        <DropdownMenuLabel>Neue Bereiche</DropdownMenuLabel>
        {CUSTOM.map(([type, Icon, desc]) => (
          <DropdownMenuItem key={type} onClick={() => onAdd(type)} className="flex items-start gap-3 py-2 cursor-pointer" data-testid={`editor-add-${type}`}>
            <Icon className="w-4 h-4 mt-0.5" />
            <div><p className="font-bold text-sm">{BLOCK_SCHEMAS[type].label}</p><p className="text-xs text-[#888B8D]">{desc}</p></div>
          </DropdownMenuItem>
        ))}
        {missing.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Entfernte Standard-Bereiche</DropdownMenuLabel>
            {missing.map(([type, s]) => (
              <DropdownMenuItem key={type} onClick={() => onAdd(type)} className="flex items-center gap-3 cursor-pointer" data-testid={`editor-add-${type}`}>
                <LayoutTemplate className="w-4 h-4" /> {s.label}
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
